// Display formatting. Centralised because the same value must read the same
// way everywhere in the app.

/** Money is INTEGER CENTS on the wire. Dividing at the edge, once, is what
 *  keeps binary floating point out of the arithmetic entirely. */
export function money(cents: number | null | undefined, currency = "USD"): string {
  if (cents == null) return "—";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency,
  }).format(cents / 100);
}

export function date(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

export function relative(iso: string | null | undefined): string {
  if (!iso) return "—";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const secs = Math.round((then - Date.now()) / 1000);
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ["year", 31536000], ["month", 2592000], ["day", 86400],
    ["hour", 3600], ["minute", 60], ["second", 1],
  ];
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  for (const [unit, s] of units) {
    if (Math.abs(secs) >= s || unit === "second") return rtf.format(Math.round(secs / s), unit);
  }
  return "—";
}

/** Renders any blueprint field type for a table cell or a detail row. */
export function display(value: unknown, type: string): string {
  if (value == null || value === "") return "—";
  switch (type) {
    case "money": return money(Number(value));
    case "date": return date(String(value));
    case "time": return dateTime(String(value));
    case "bool": return value ? "Yes" : "No";
    case "json": return JSON.stringify(value);
    default: return String(value);
  }
}
